/**
 * A dialog opens with the cursor in its first field, not on the «i» of its title
 * (which would open the explanation at once).
 */
export function focusFirstField(event: Event) {
	const field = (event.target as HTMLElement | null)?.querySelector<HTMLElement>(
		'select:not(:disabled), input:not(:disabled), textarea:not(:disabled)',
	)
	if (!field) return
	event.preventDefault()
	field.focus()
}
